import { SILVERSTRIPE_ENDPOINT } from './index'

// Rechtstexte liegen als Seiten im SilverStripe-CMS
export const PRIVACY_URL = `${SILVERSTRIPE_ENDPOINT}/datenschutz/`
export const IMPRINT_URL = `${SILVERSTRIPE_ENDPOINT}/impressum/`
